(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      setTimeout(()=>{
        document.getElementById(`Details-HeaderMenuMobile-1`).addEventListener("click", () => this.showMobileMenu(1));
        document.getElementById(`Details-HeaderMenuMobile-2`).addEventListener("click", () => this.showMobileMenu(2));
        document.getElementById(`Details-HeaderMenuMobile-3`).addEventListener("click", () => this.showMobileMenu(3));
        document.getElementById(`Details-HeaderMenuMobile-4`).addEventListener("click", () => this.showMobileMenu(4));
        document.getElementById(`Details-HeaderMenuMobile-5`).addEventListener("click", () => this.showMobileMenu(5));
        this.showMobileMenu(1);
        document.getElementById(`Details-Search-1`).addEventListener("click", () => this.showMobileSearch(1));
        document.getElementById(`Details-Search-2`).addEventListener("click", () => this.showMobileSearch(2));
        document.getElementById(`Details-Search-3`).addEventListener("click", () => this.showMobileSearch(3));
        document.getElementById(`Details-Search-4`).addEventListener("click", () => this.showMobileSearch(4));
        document.getElementById(`Details-Search-5`).addEventListener("click", () => this.showMobileSearch(5));
        this.showMobileSearch(1);
      },500)
      // for(let i=0;i<this.section.settings.menu.links.length;i++){
      //   console.log(this.section.settings.menu.links[i])
      // }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    showMobileMenu(id) {
      for(let i = 1;i<6;i++) {
        let _t1 = document.getElementById(`Mobile-Content-${i}`)
        let _t2 = document.getElementById(`Details-HeaderMenuMobile-${i}`)
        if(_t1 && _t2) {
          if(i === id) {
              _t1.classList.add("menu-mobile-content-active")
              _t2.classList.add("menu-mobile-tab-active")
          } else {
            _t1.classList.remove("menu-mobile-content-active")
            _t2.classList.remove("menu-mobile-tab-active")
          }
        }
      }
    }

    showMobileSearch(id) {
      // for(let i = 1;i<5;i++) {
      //   if(i === id) {
      //     document.getElementById(`Mobile-Search-${i}`).classList.add("menu-mobile-content-active")
      //     document.getElementById(`Details-Search-${i}`).classList.add("menu-mobile-tab-active")
      //   } else {
      //     document.getElementById(`Mobile-Search-${i}`).classList.remove("menu-mobile-content-active")
      //     document.getElementById(`Details-Search-${i}`).classList.remove("menu-mobile-tab-active")
      //   }
      // }
      for(let i = 1;i<6;i++) {
        let _t1 = document.getElementById(`Mobile-Search-${i}`)
        let _t2 = document.getElementById(`Details-Search-${i}`)
        if(_t1 && _t2) {
          if(i === id) {
              _t1.classList.add("menu-mobile-content-active")
              _t2.classList.add("menu-mobile-tab-active")
          } else {
            _t1.classList.remove("menu-mobile-content-active")
            _t2.classList.remove("menu-mobile-tab-active")
          }
        }
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
